import { useContext } from 'react';
import { SearchLoadingBrandContext, SearchResultsBrandContext } from '@/containers/WorkspaceGlobalSearch/Context';
import { formatPlurality } from '@trinity/chat-components';
import Table from './Search.Table.Brands';
import styles from './style/Tab.module.css';

const max = 50;

export default function SearchTabBrands() {
  const brands = useContext(SearchResultsBrandContext);
  const loading = useContext(SearchLoadingBrandContext);

  const isLoading = loading.untouched && loading.loading;

  const data = brands?.items ?? [];
  const countText = !isLoading
    ? `(${getCountLabel(brands?.total ?? 0, 'Brand')})`
    : null;
  const pagination = data.length > 25;

  return (
    <div className={styles.root}>
      <Table
        data={data}
        countText={countText}
        pagination={pagination}
        pageSize={25}
        isLoading={isLoading} />
    </div>
  );
}

function getCountLabel(total: number, label: string) {
  return total > max
    ? `+${max} ${formatPlurality(label, max)}`
    : `${total} ${formatPlurality(label, total)}`;
}

export { SearchTabBrands };